var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V2H16.5V14H6V15.5H19.5V14H18V0.5H0ZM3.0015 2.75C2.20656 2.75276 1.44495 3.06968 0.882703 3.63164C0.320454 4.19361 0.00316229 4.95506 0 5.75C0 7.39925 1.353 8.75 3.0015 8.75C3.79604 8.74684 4.55711 8.4297 5.1188 7.86774C5.68048 7.30577 5.99724 6.54454 6 5.75C6 4.10225 4.6485 2.75 3.0015 2.75ZM7.5 3.5V5H11.25V3.5H7.5ZM12.75 3.5V5H15V3.5H12.75ZM3.0015 4.25C3.837 4.25 4.5 4.91225 4.5 5.75C4.5 6.59 3.83775 7.25 3.0015 7.25C2.1615 7.25 1.5 6.59 1.5 5.75C1.5 4.91225 2.16225 4.25 3.0015 4.25ZM7.5 6.5V8H15V6.5H7.5ZM0 9.5V15.5H1.5V11H3.75V15.5H5.25V11.4935L6.798 12.3125C7.23675 12.545 7.764 12.5442 8.202 12.3125V12.314L10.8495 10.9137L10.1498 9.58625L7.5015 10.9865L5.1795 9.761C4.85544 9.5898 4.49451 9.50021 4.128 9.5H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.30327342.svg";
export { ForwardRef as ReactComponent };